/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tfield_Open_Rounds_DescInputs */



/**
* | output |
* | --- |
* | "Casual format: each player plays up to a set number of rounds. No ranking." |
*
* @param {Tfield_Open_Rounds_DescInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tfield_open_rounds_desc = /** @type {((inputs?: Tfield_Open_Rounds_DescInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tfield_Open_Rounds_DescInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Format décontracté : chaque joueur joue jusqu'à un nombre de rondes fixé. Pas de classement.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Formato informal: cada jugador juega hasta un número fijo de rondas. Sin clasificación.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Formato casual: cada jogador joga até um número fixo de rodadas. Sem classificação.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Formato informale: ogni giocatore gioca fino a un numero fisso di round. Nessuna classifica.")
	return /** @type {LocalizedString} */ ("Casual format: each player plays up to a set number of rounds. No ranking.")
});